var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "claim" } },
    [
      _c(
        "div",
        { staticClass: "yto-box search-form y-pb-0" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.form, "label-width": "130px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "time-style",
                      attrs: { prop: "createTime", "label-width": "0" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "timetype-style",
                          attrs: { placeholder: "活动区域" },
                          model: {
                            value: _vm.form.queryType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "queryType", $$v)
                            },
                            expression: "form.queryType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "发起时间", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "通过时间", value: "2" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "yto-date-picker",
                        {
                          staticClass: "date-style",
                          attrs: {
                            maxRangeVal: 31,
                            "picker-options": _vm.pickerOptions1,
                            "value-format": "yyyy-MM-dd",
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                          },
                          model: {
                            value: _vm.form.createTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "createTime", $$v)
                            },
                            expression: "form.createTime",
                          },
                        },
                        [_vm._v(" >")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "indemnityType", label: "理赔类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.indemnityType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "indemnityType", $$v)
                            },
                            expression: "form.indemnityType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _vm._l(_vm.indemnityTypeList, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.name, value: item.code },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "理赔状态", prop: "indemnityStatus" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          on: {
                            change: function ($event) {
                              return _vm.pageChange(1)
                            },
                          },
                          model: {
                            value: _vm.form.indemnityStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "indemnityStatus", $$v)
                            },
                            expression: "form.indemnityStatus",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "0" } }, [
                            _vm._v("全部 " + _vm._s(_vm.statusCount[0] || 0)),
                          ]),
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v(
                              "待上传凭证 " + _vm._s(_vm.statusCount[1] || 0)
                            ),
                          ]),
                          _c("el-radio-button", { attrs: { label: "2" } }, [
                            _vm._v("待审核 " + _vm._s(_vm.statusCount[2] || 0)),
                          ]),
                          _c("el-radio-button", { attrs: { label: "3" } }, [
                            _vm._v(
                              "审核未通过 " + _vm._s(_vm.statusCount[3] || 0)
                            ),
                          ]),
                          _c("el-radio-button", { attrs: { label: "4" } }, [
                            _vm._v(
                              "审核通过 " + _vm._s(_vm.statusCount[4] || 0)
                            ),
                          ]),
                          _c("el-radio-button", { attrs: { label: "5" } }, [
                            _vm._v(
                              "取消理赔 " + _vm._s(_vm.statusCount[5] || 0)
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "运单号", prop: "waybillNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.waybillNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "waybillNo", $$v)
                          },
                          expression: "form.waybillNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户编码", prop: "customerCode" } },
                    [
                      _c("el-autocomplete", {
                        attrs: {
                          clearable: "",
                          "fetch-suggestions": _vm.querySearch,
                          placeholder: "请输入",
                        },
                        on: {
                          select: _vm.handleSelect,
                          clear: _vm.clearCustomerCode,
                          input: _vm.changeShopCode,
                        },
                        model: {
                          value: _vm.form.customerCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customerCode", $$v)
                          },
                          expression: "form.customerCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺名称", prop: "shopCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.shopCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shopCode", $$v)
                            },
                            expression: "form.shopCode",
                          },
                        },
                        _vm._l(_vm.shopList, function (item) {
                          return _c("el-option", {
                            key: item.shopId,
                            attrs: { label: item.shopName, value: item.shopId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { float: "right", "margin-right": "0" } },
                    [
                      _c(
                        "div",
                        { staticClass: "button-group" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pageChange(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "normal-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("searchForm")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-refresh-left y-fc-4C84FF",
                              }),
                              _vm._v("重置"),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                loading: _vm.exportLoading,
                                disabled: _vm.tableLoading || _vm.total === 0,
                              },
                              on: { click: _vm.exportFile },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-download y-fc-4C84FF",
                              }),
                              _vm._v("导出"),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "yto-box y-pb-0" }, [
        _c(
          "div",
          { staticClass: "mb20" },
          [
            _c(
              "el-button",
              {
                staticClass: "mr20 copyBtn",
                attrs: { type: "primary" },
                on: { click: _vm.handleOrder },
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/images/icon_faqilipei.png") },
                }),
                _vm._v("发起理赔"),
              ]
            ),
            _c(
              "el-tooltip",
              {
                staticClass: "tooltip-style",
                attrs: { effect: "light", placement: "bottom-start" },
              },
              [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v(
                      "理赔状态：待上传凭证、待审核、审核未通过、审核通过、取消理赔；"
                    ),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v(
                      "待上传凭证：网点发起理赔，需要客户上传物品价值证明，理赔金额；"
                    ),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v("待审核：客户发起理赔，需网点审核；"),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v(
                      "审核未通过：网点审核为不通过，客户可修改理赔信息后重新提交审核；"
                    ),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v("审核通过：网点审核为通过；"),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v(
                      "取消理赔：发起理赔后，快件重新找到派送或其他不需要理赔时，网点取消理赔；"
                    ),
                  ]),
                ]),
                _c("span", { staticClass: "helpInfo" }, [
                  _c("i", {
                    staticClass: "el-icon-warning systemColor helpIcon mr5",
                    staticStyle: { cursor: "pointer" },
                  }),
                  _vm._v("理赔须知"),
                ]),
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "normal-btn setting-btn",
                attrs: { loading: _vm.btnLoading },
                on: { click: _vm.openCollectionAccount },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/icon_shoukuanzhanghu.png"),
                  },
                }),
                _vm._v("设置收款账户"),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "yto-table" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "waybillNo",
                    label: "运单号",
                    align: "center",
                    width: "140px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "hilightColor",
                              on: {
                                click: function ($event) {
                                  return _vm.showWaybillDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.waybillNo))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "customerCode",
                    label: "客户编码",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.customerCode
                            ? _c("span", [
                                _vm._v(_vm._s(scope.row.customerCode)),
                              ])
                            : _vm._e(),
                          scope.row.customerCode && scope.row.customerName
                            ? _c("span", [_vm._v(" - ")])
                            : _vm._e(),
                          scope.row.customerName
                            ? _c("span", [
                                _vm._v(_vm._s(scope.row.customerName)),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "shopName",
                    "min-width": "100px",
                    label: "店铺名称",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "branchName",
                    "min-width": "100px",
                    label: "网点",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityType",
                    label: "理赔类型",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.indemnityType === "1"
                            ? _c("span", [_vm._v("破损")])
                            : _vm._e(),
                          scope.row.indemnityType === "2"
                            ? _c("span", [_vm._v("遗失")])
                            : _vm._e(),
                          scope.row.indemnityType === "3"
                            ? _c("span", [_vm._v("延误")])
                            : _vm._e(),
                          scope.row.indemnityType === "4"
                            ? _c("span", [_vm._v("其他")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityStatus",
                    label: "理赔状态",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.indemnityStatus === "1"
                            ? _c("span", [_vm._v("待上传凭证")])
                            : _vm._e(),
                          scope.row.indemnityStatus === "2"
                            ? _c("span", [_vm._v("待审核")])
                            : _vm._e(),
                          scope.row.indemnityStatus === "3"
                            ? _c("span", [_vm._v("审核未通过")])
                            : _vm._e(),
                          scope.row.indemnityStatus === "4"
                            ? _c("span", [_vm._v("审核通过")])
                            : _vm._e(),
                          scope.row.indemnityStatus === "5"
                            ? _c("span", [_vm._v("取消理赔")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "bigCustomerName",
                    label: "物品类型",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.indemnityGoodsType === "1"
                            ? _c("span", [_vm._v("生活用品")])
                            : _vm._e(),
                          scope.row.indemnityGoodsType === "2"
                            ? _c("span", [_vm._v("服饰鞋帽")])
                            : _vm._e(),
                          scope.row.indemnityGoodsType === "3"
                            ? _c("span", [_vm._v("食品")])
                            : _vm._e(),
                          scope.row.indemnityGoodsType === "4"
                            ? _c("span", [_vm._v("文件")])
                            : _vm._e(),
                          scope.row.indemnityGoodsType === "5"
                            ? _c("span", [_vm._v("数码产品")])
                            : _vm._e(),
                          scope.row.indemnityGoodsType === "6"
                            ? _c("span", [_vm._v("其他")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityGoodsWorthStr",
                    label: "物品价值(元)",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityAmountStr",
                    label: "理赔金额(元)",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "发起时间",
                    align: "center",
                    width: "150px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sponsorInfor",
                    label: "创建人",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "approvedTime",
                    label: "审核通过时间",
                    align: "center",
                    width: "150px",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "80px", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleOrder(scope.row)
                                },
                              },
                            },
                            [_vm._v("处理")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "mt20" }, [
              _vm._v("合计理赔金额：" + _vm._s(_vm.allAmout) + "元"),
            ]),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50],
                "page-size": _vm.pageSize,
                total: _vm.total,
                layout: "total, sizes, prev, pager, next",
              },
              on: {
                "size-change": _vm.limitChange,
                "current-change": _vm.pageChange,
                "update:currentPage": function ($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function ($event) {
                  _vm.currentPage = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm.showDialog
        ? _c("orderTrackingDetails", {
            ref: "orderTrackingDetails",
            attrs: { value: _vm.showDialog, data: _vm.orderDetailsData },
            on: { close: _vm.closeDetailInfo },
          })
        : _vm._e(),
      _vm.handleClaimDialog
        ? _c("handleClaimOrder", {
            ref: "handleClaimOrder",
            attrs: { value: _vm.handleClaimDialog, data: _vm.handleClaimData },
            on: {
              close: _vm.closehandleClaim,
              updataClaimList: _vm.updataClaimList,
            },
          })
        : _vm._e(),
      _vm.collectionAccountDialog
        ? _c("setCollectionAccount", {
            ref: "setCollectionAccount",
            attrs: {
              value: _vm.collectionAccountDialog,
              data: _vm.collectionAccountData,
            },
            on: { close: _vm.closeCollectionAccount },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "imgDialog",
          attrs: { visible: _vm.dialogVisible, title: "图片" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeImg,
          },
        },
        [
          _c("div", [
            _c("img", {
              staticStyle: { display: "block", margin: "0 auto" },
              attrs: { width: "80%", src: _vm.dialogImageUrl, alt: "" },
            }),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            center: "",
            visible: _vm.tipDialogVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialogVisible = $event
            },
          },
        },
        [
          [
            _c("p", { staticClass: "y-fc-000 y-fs-14 y-fl-20 y-mt-0" }, [
              _vm._v(
                "温馨提示：客户管家【发起的工单】已支持上报理赔，可通过“直通总部-快速理赔”上报。"
              ),
            ]),
            _c("img", {
              attrs: {
                width: "100%",
                src: require("@/assets/images/lipei_tipBg.png"),
              },
            }),
          ],
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeTipDialog },
                },
                [_vm._v("我知道了")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }